<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="d-flex form-heading title-section form-section ">
              <p class="form-title text-center" style="font-size: 35px;">
                NEW JERSEY POLICYHOLDER NOTICE
              <br>
                <strong>NOTICE PURSUANT TO N.J.A.C. 11:1-33.3</strong>
              </p>

            </article>
            <article class="input-section form-section">
              <div >
                <p class="mb-3 ar-sl-disclosure">
                  
                    The undersigned applicant has been advised by the undersigned originating insurance producer and understands that an insurance policy written by a surplus lines insurer is not subject to the filing or approval requirements of the New Jersey Department of Banking and Insurance. Such a policy may contain conditions, limitations and different terms than a policy issued by an insurer granted a Certificate of Authority by the New Jersey Department of Banking and Insurance.</p>
              </div>
            </article>
            <article class="form-heading form-section review-sign input-section">
              <div class="row">

                <div class="col-md-7">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date" style="text-align: left">Solicited Person's Signature:</p>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Your Name to Sign"
                      name="slDisclosureSignature"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="quote.slDisclosureSignature"
                    >
                    <span
                      v-show="errors.has('slDisclosureSignature')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('slDisclosureSignature') | filterText }}</span>
                  </section>
                </div>
              </div>
              <div class="row">

                <div class="col-md-7">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date" style="text-align: left">Solicited Person's Name (Print Name):</p>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Name of Applicant"
                      v-model="quote.fullLegalNameOfApplicant"
                      disabled
                    >
                  </section>
                </div>
              </div>
              <div class="row">

                <div class="col-md-7">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date" style="text-align: left" >Producer Signature:</p>

                    <img src="../../../public/assets/images/sign.png" alt="Sign" style="max-height: 40px;" class="notice-form-date-sl-fl-text">
                  </section>
                </div>
              </div>
              <div class="row">

                <div class="col-md-7">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date" style="text-align: left">Producer Name (Print or Type):</p>
                    <p class="notice-form-date-sl-fl-text"> Isaac Peck</p>
                  </section>
                </div>
              </div>
              <div class="row">

                <div class="col-md-7">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date" style="text-align: left">New Jersey Producer License Reference Number:</p>
                    <p class="notice-form-date-sl-fl-text"> #3001340180 </p>
                  </section>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'home-inspector-6'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-4')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-5')" v-if="!state.signedInUser"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-6')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-7')"               v-if="quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' && (checkServices('real estate agent') || checkServices('contractor') || checkServices('engineer') || checkServices('pest inspector'))"
              ></button>
              <span class="pagination-dots pagination-current"></span>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              @click="formSubmit()"
              :disabled="!state.pageSlDisclosureIsValid"
              :class="{submitDisabled: !state.pageSlDisclosureIsValid}"
            >Submit</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Processing...</span>
    </div>

  </div>
</template>

<script>
  import $ from "jquery";
  import moment from 'moment';
  import { STATUS } from "../../utils/constants";

  export default {
    name: "home-inspector-6",
    data() {
      return {
        loading: false
      };
    },
    computed: {
      quote() {
        return this.$store.state.homeInspector.quote;
      },
      state() {
        return this.$store.state.homeInspector;
      },
      errorMsg() {
        return this.$store.state.homeInspector.errorMsg;
      }
    },
    watch: {
      errorMsg: {
        handler() {
          if (this.errorMsg) {
            this.loading = false;
            this.$notify({
              group: 'error',
              type: 'error',
              title: 'Error',
              text: this.errorMsg
            });
          }
        }
      }
    },
    methods: {
      navigateToPrev(route) {
        this.$router.push({
          name: route
        });
      },
      next(routeName) {
        this.$router.push({
          name: routeName
        });
      },
      checkServices(service) {
        return this.quote.applicantOrAssociateReportMode.includes(service);
      },
      validateBeforeSubmit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.state.pageSlDisclosureIsValid = true;
            return;
          }
          this.state.pageSlDisclosureIsValid = false;
        });
      },

      formattedCurrentDate() {
        return moment(this.quote.applicantPrincipleEsignatureDatetime).format('YYYY-MM-DD');
      },
      formSubmit() {
        this.loading = true;
        this.quote.status = STATUS.Submitted;
        this.quote.noticeType = 'PH';
        this.$store.dispatch('homeInspector/createSlDisclosure');
      }

    },


    filters: {
      filterText(x) {
        if (x !== undefined) {
          if (x.indexOf("req") !== -1) {
            return "This field is required";
          } else {
            return x.replace("_", " ");
          }
        }
      }
    },

    mounted() {
      $('html, body').animate({
        scrollTop: $('.orep-header').offset().top
      }, 500);
    },

    components: {}
  };
</script>

<style scoped>
  strong {
    text-decoration: underline;
  }
  .form-inline > label {
    width: 82px;
    text-align: left;
  }
  .form-heading > p {
    font-size: 35px;
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .form-errors,
  .js-input-errors {
    display: block;
    text-transform: initial;
    font-size: 13px;
    width: 90%;
    margin: auto;
    position: relative;
    top: -29px;
  }
  fieldset {
    font-size: 12px;
  }
  .logo {
    width: 150px;
    height: 45px;
    object-fit: contain;
  }
  h6 {
    font-size: 14px;
  }
  h5 {
    font-size: 16px;
  }
  .company-info-content {
    padding: 10px 30px;
    border: 1px solid black;
  }
  .fs-subtitle {
    margin: 20px 0;
    border-bottom: 2px solid black;
  }
  table.oreptable {
    font-size: 14px;
    margin-left: auto;
    margin-right: auto;
  }
  .gen-inf {
    display: flex;
    background: #eee none repeat scroll 0 0;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 7px;
    text-align: left;
    height: 30px;
    border: 1px solid black;
  }
  .underline-value {
    margin-left: 10px;
    margin-right: 40px;
    border-bottom: 1px solid black;
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 14px;
  }
  .table th, .table td {
    text-align: center;
    vertical-align: middle;
  }
  .table.ar td, .table.ar th {
    border-left: 1px solid #ddd !important;
    border-top: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
  }
  .w-20 {
    width: 20%;
  }
  .blank_th {
    width: 210px;
  }
  .footer-company-info {
    background-color: yellow;
    border: 1px solid black;
    padding: 10px 20px 40px;
  }
  .form-check-input {
    position: relative;
    margin-left: 0;
  }
  .page-content p, .page-content li {
    font-size: 15px;
  }
  .p-56, .notice-list > li, .notice-info {
    padding-right: 56px;
  }
</style>

